import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { CircularProgress, Theme, Typography } from '@mui/material'

export type LoadingScreenProps = ExtendableStyles & {
  message?: string
  hideBackground?: boolean
  overlay?: boolean
}

export function LoadingScreen({
  className,
  style,
  hideBackground = false,
  overlay = true,
  message,
}: LoadingScreenProps) {
  const { classes } = useStyles()
  return (
    <div
      className={classNames(
        className,
        classes.container,
        overlay && classes.fillParent,
        classes.background,
        hideBackground && classes.backgroundOverlay
      )}
      style={style}
    >
      <div className={classes.content}>
        <CircularProgress />
        {!!message && (
          <Typography className={classes.message} variant="h4">
            {message}
          </Typography>
        )}
      </div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(2),
  },
  fillParent: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  background: {
    backgroundColor: 'white',
  },
  backgroundOverlay: {
    backgroundColor: 'rgba(255,255,255,0.3)',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  message: {
    marginTop: spacing(3),
    marginLeft: spacing(7.5),
    marginRight: spacing(7.5),
    textAlign: 'center',
  },
}))
